import { schema } from 'normalizr';

const feedbackFormSchema = new schema.Entity('feedbackForms', {});

export default feedbackFormSchema;
